import React from 'react';

export interface RangeSliderProps {
  readonly value: number;
  readonly min: number;
  readonly max: number;
  readonly width?: number;

  readonly onChange: (value: number) => void;
}

/** widget that shows a number & lets you drag a slider to change it */
export function RangeSlider(props: RangeSliderProps) {
  return (
    <input type="range" value={props.value} min={props.min} max={props.max} style={{ width: props.width }}
      onChange={e => props.onChange(e.target.valueAsNumber)}
    />
  );
}
